(() => {
  function initialise(root) {
    if (root.dataset.deliveryReady) return;
    const form = root.querySelector('form');
    const original = form?.querySelector('[data-wm-submit]');
    const select = form?.querySelector('[data-wm-plan]');
    const copyNode = root.querySelector('[data-wm-delivery-copy]');
    if (!form || !original || !select || !copyNode) return;
    const copy = JSON.parse(copyNode.textContent);
    const product = JSON.parse(form.querySelector('[data-wm-product]').textContent);
    const variant = form.querySelector('[data-wm-variant]');
    const addons = [...form.querySelectorAll('[data-wm-addon]')];
    const message = form.querySelector('[data-wm-message]');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency', currency:root.dataset.currency}).format(cents / 100);
    const node = (tag, className, text) => {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text) el.textContent = text;
      return el;
    };
    const trigger = node('button', 'wm-button wm-delivery-trigger', copy.choose);
    trigger.type = 'button';
    trigger.dataset.wmChooseDelivery = '';
    const dialog = node('dialog', 'wm-delivery-dialog');
    dialog.id = `Delivery-${form.getAttribute('id')}`;
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    const heading = node('h2', 'wm-delivery-title', copy.title);
    heading.id = `${dialog.id}-title`;
    dialog.setAttribute('aria-labelledby', heading.id);
    const back = node('button', 'wm-delivery-back', copy.back);
    back.type = 'button';
    const description = node('p', 'wm-delivery-intro', copy.intro);
    const group = node('fieldset', 'wm-delivery-options');
    group.append(node('legend', 'wm-visually-hidden', copy.title));
    const choices = [...select.options].map((option, index) => {
      const id = option.value;
      const label = node('label', 'wm-delivery-option');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.dataset.wmDeliveryChoice = ''; 
      radio.name = `delivery-choice-${form.getAttribute('id')}`;
      radio.value = id;
      radio.id = `${dialog.id}-${index}`;
      label.htmlFor = radio.id;
      const text = node('span', 'wm-delivery-option-copy');
      const title = node('strong', 'wm-delivery-option-title', id === '3179053227' ? copy.twoMonths : id === '3184689323' ? copy.monthly : id ? option.text.split('·')[0].trim() : copy.once);
      const interval = node('span', 'wm-delivery-interval', id === '3179053227' ? copy.twoMonthsNote : id === '3184689323' ? copy.monthlyNote : id ? copy.subscription : copy.onceNote);
      const price = node('strong', 'wm-delivery-option-price');
      const regular = node('s', 'wm-delivery-was');
      const saving = node('span', 'wm-delivery-saving');
      const prices = node('span', 'wm-delivery-prices');
      prices.append(price, regular);
      text.append(title, interval, saving);
      label.append(radio, text, prices);
      group.append(label);
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        select.value = id;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        render();
      });
      return {id, radio, label, price, regular, saving};
    });
    const reassurance = node('p', 'wm-delivery-reassurance', copy.reassurance);
    const delivery = node('p', 'wm-delivery-free', copy.free);
    const final = node('button', 'wm-button wm-delivery-checkout');
    final.type = 'submit';
    final.dataset.wmDeliveryCheckout = '';
    const status = node('p', 'wm-delivery-status');
    status.setAttribute('role', 'alert');
    dialog.append(back, node('p', 'wm-delivery-eyebrow', copy.eyebrow), heading, description, group, delivery, reassurance, final, status);
    original.before(trigger);
    original.hidden = true;
    form.append(dialog);
    root.classList.add('wm-delivery-step');
    root.dataset.deliveryReady = 'true';
    function quote(planId) {
      const selected = product.variants.find(item => String(item.id) === variant.value);
      const allocation = selected?.selling_plan_allocations?.find(item => String(item.selling_plan_id) === planId);
      let valid = Boolean(selected?.available && (!planId || allocation));
      let cents = Number(allocation?.price ?? selected?.price ?? 0);
      for (const input of addons) {
        const quantity = Number(input.value) || 0;
        if (!quantity) continue;
        const extra = product.addons?.find(item => String(item.id) === input.dataset.variant);
        const extraPlan = extra?.selling_plan_allocations?.find(item => String(item.selling_plan_id) === planId);
        valid = valid && Boolean(extra?.available && (!planId || extraPlan));
        cents += quantity * Number(extraPlan?.price ?? input.dataset.price ?? 0);
      }
      return {cents, valid};
    }
    function render() {
      const regular = quote('').cents;
      for (const choice of choices) {
        const price = quote(choice.id);
        const saved = Math.max(0, regular - price.cents);
        choice.radio.checked = choice.id === select.value;
        choice.radio.disabled = !price.valid;
        choice.label.classList.toggle('is-unavailable', !price.valid);
        choice.price.textContent = money(price.cents);
        choice.regular.hidden = saved === 0;
        choice.regular.textContent = money(regular);
        choice.saving.hidden = saved === 0;
        choice.saving.textContent = copy.saving.replace('{amount}', money(saved));
      }
      trigger.disabled = original.disabled;
      final.disabled = original.disabled;
      const loading = original.textContent === root.dataset.loading;
      final.textContent = loading ? root.dataset.loading : `${copy.addToCart} · ${money(quote(select.value).cents)} →`;
      status.textContent = message?.textContent || '';
    }
    function open() {
      render();
      if (trigger.disabled) return;
      if (!dialog.open) dialog.showModal();
    }
    trigger.addEventListener('click', open);
    back.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => trigger.focus());
    form.addEventListener('submit', event => {
      if (dialog.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }, true);
    form.addEventListener('input', event => {
      if (!event.target.hasAttribute('data-wm-delivery-choice')) queueMicrotask(render);
    });
    form.addEventListener('change', () => queueMicrotask(render));
    const observer = new MutationObserver(render);
    observer.observe(original, {attributes:true, attributeFilter:['disabled'], childList:true, subtree:true, characterData:true});
    if (message) observer.observe(message, {childList:true, subtree:true, characterData:true});
    render();
  }
  document.querySelectorAll('[data-wm-box]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wm-box]').forEach(initialise));
})();

